import React, { useState } from 'react';

const Registro: React.FC = () => {
  const [step, setStep] = useState<number>(1);

  const nextStep = () => {
    setStep((prevStep) => Math.min(prevStep + 1, 3));
  };

  const prevStep = () => {
    setStep((prevStep) => Math.max(prevStep - 1, 1));
  };

  const handleSubmit = () => {
    // Lógica para enviar el formulario
    console.log('Formulario enviado');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-200 flex flex-col justify-center items-center">
      <div className="w-full max-w-2xl bg-white rounded-lg shadow-lg p-8">
        <Stepper step={step} />
        {step === 1 && <UserInfo />}
        {step === 2 && <Address />}
        {step === 3 && <Profile />}
        <div className="flex justify-between mt-8">
          {step > 1 && (
            <button onClick={prevStep} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-full">
              Anterior
            </button>
          )}
          {step < 3 ? (
            <button onClick={nextStep} className="bg-blue-500 text-white px-4 py-2 rounded-full">
              Siguiente
            </button>
          ) : (
            <button onClick={handleSubmit} className="bg-blue-500 text-white px-4 py-2 rounded-full">
              Enviar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const Stepper: React.FC<{ step: number }> = ({ step }) => {
  return (
    <div className="flex justify-between items-center mb-8">
      {['Informacion Personal', 'Domicilio', 'Perfil'].map((label, index) => (
        <div key={index} className="flex-1">
          <div className={`w-full h-1 ${step > index + 1 ? 'bg-blue-500' : 'bg-gray-200'}`} />
          <div className="text-center mt-2">
            <span className={`${step === index + 1 ? 'text-blue-500' : 'text-gray-500'}`}>
              {label}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

const UserInfo: React.FC = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Informacion Personal</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input type="text" placeholder="Primer Nombre" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Segundo Nombre" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Empresa" className="border p-3 rounded-lg w-full" />
        <input type="email" placeholder="Email " className="border p-3 rounded-lg w-full" />
        <input type="password" placeholder="Contraseña" className="border p-3 rounded-lg w-full" />
        <input type="password" placeholder="Confirmar Contraseña" className="border p-3 rounded-lg w-full" />
      </div>
    </div>
  );
};

const Address: React.FC = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Domicilio</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input type="text" placeholder="Direccion" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Ciudad" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Departamento" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Codigo postal" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Pais" className="border p-3 rounded-lg w-full" />
      </div>
    </div>
  );
};

const Profile: React.FC = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Perfil</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input type="text" placeholder="Username" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Bio" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Website" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="Twitter" className="border p-3 rounded-lg w-full" />
        <input type="text" placeholder="LinkedIn" className="border p-3 rounded-lg w-full" />
      </div>
    </div>
  );
};

export default Registro;
